import React__default from 'react';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '../../../node_modules/@fortawesome/react-fontawesome/index.es.js';
import { faTimes } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index.js';
import { NvButton } from '../NvButton/component.js';
import { NvMultiStage } from '../NvMultiStage/component.js';
import styles from './styles.module.scss.js';
import { COLORS } from '../../../helpers/constants.js';

/**
 * @description Nimvelo Modal component
 * @props allowClickOutside, children, className, dimBackground, kind, modalRoot, onClose, show, size, title, type,
 * onComplete, stages, showStageNumbers, showStageProgressBar, completeButtonText, cancelText, confirmText
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const NvModal = ({ allowClickOutside = true, disabled, children, className, dimBackground, kind = 'primary', modalRoot, onClose = () => { }, show = false, size = 'standard', title, type = 'alert', 
// * multistage props
onComplete = () => { }, stages, defaultState, showStageNumbers, showStageProgressBar, completeButtonText, 
// * confirm props
cancelText, confirmText, 
// * action props
buttons = [], }) => {
    // * for checking if we can use createPortal
    const isReact16 = parseFloat(React__default.version) > 16;
    const modalContainerClasses = `${styles.modal}`;
    // * typing colors constant
    const colors = COLORS;
    const modalKind = {
        '--NvModalColor': colors[kind.toUpperCase()],
    };
    const closeModal = (confirmed = false) => () => {
        onClose(confirmed);
    };
    const backdrop = (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    React__default.createElement("div", { role: "button", tabIndex: -1, onKeyDown: undefined, className: `${styles.backdrop} ${dimBackground && styles.dim}`, onClick: allowClickOutside ? closeModal() : undefined }));
    const modalContainer = show ? (React__default.createElement("div", { className: `${modalContainerClasses} ${show && styles.show} `, style: modalKind },
        backdrop,
        React__default.createElement("div", { className: `${styles.modal_body} ${styles[size]} ${className}` },
            React__default.createElement("div", { className: styles.title },
                title || '\u00A0',
                React__default.createElement("button", { type: "button", className: styles.close_button, onClick: closeModal() },
                    React__default.createElement(FontAwesomeIcon, { icon: faTimes }))),
            type === 'multi-stage' && stages ? (React__default.createElement(NvMultiStage, { disabled: disabled, onComplete: onComplete, stages: stages, completeButtonText: completeButtonText, showStageNumbers: showStageNumbers, showStageProgressBar: showStageProgressBar, defaultState: defaultState, fullWidth: true })) : (React__default.createElement("div", { className: styles.modal_content_wrapper },
                React__default.createElement("div", { className: styles.modal_content }, children))),
            type === 'confirm' && (React__default.createElement("div", { className: styles.controls },
                React__default.createElement(NvButton, { disabled: disabled, size: "standard", kind: "danger", onClick: closeModal(), fullWidth: true }, cancelText || 'No'),
                React__default.createElement(NvButton, { disabled: disabled, size: "standard", onClick: closeModal(true), fullWidth: true }, confirmText || 'Yes'))),
            type === 'action' && (React__default.createElement("div", { className: styles.controls }, buttons.map(button => (React__default.createElement(NvButton, { disabled: disabled, key: button.kind + button.text, size: "standard", kind: button.kind, onClick: () => {
                    button.onClick(closeModal());
                }, fullWidth: true }, button.text)))))))) : null;
    // * if we have a modalRoot from props and react supports portal
    if (modalRoot && isReact16)
        return createPortal(modalContainer, modalRoot);
    return modalContainer;
};

export { NvModal, NvModal as default };
//# sourceMappingURL=component.js.map
